// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app__menu_menu-button {
  width: 100px;
  border: solid 0.000000000005em #000;
  height: 27px;
  border-radius: 7px;
  color: #000;
  font-family: "SawtonCircular-Medium";
  font-size: 20px;
  font-weight: 550;
  background-color: transparent;
  cursor: pointer;
}

.app__menu_menu-button.active,
.app__menu_menu-button:hover {
  border: none;
  color: var(--color-white);
  background-color: var(--color-blue);
}
.app__menu_container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 50px;
}
.app__menu_container_buttons {
  display: flex;
  gap: 15px;
  padding-bottom: 50px;
}
.app__menu_menu-name {
  font-size: 2rem;
  color: #000;
  font-weight: 600;
}
.app__menu_menu-preise {
  font-size: 1.5rem;
  color: #000;
  font-weight: 600;
}
.app__menu_menu-beschreibung {
  font-size: 1.25rem;
}

.app__menu_menu-item-Menü {
  text-align: center;
  padding: 20px;
}
.app__menu_menu-item-Brunch {
  text-align: center;
  padding: 5px 20px;
}
.app__menu_menu-item-A_La_Cart {
  text-align: center;
  padding: 20px;
}
.app__menu_category {
  font-size: 3rem;
  color: #000;
  font-weight: 600;
}
.app__menu-heading {
  padding-bottom: 50px;
}
.app__menu_category-container {
  display: flex;
  flex-direction: column;
  text-align: center;
  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: calc(50% - 10px);
  width: unset;
  min-height: 350px;
}
.app__menu_items_container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
.app__menu_container-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  max-width: 500px;
}
.app__menu_container-text_heading {
  font-size: 3rem;
  color: #000;
  font-weight: 600;
  padding: 20px 0;
}
.app__menu_container-text_beschreibung {
  font-size: 1.25rem;
  line-height: 30px;
  padding-bottom: 50px;
}
@media screen and (max-width: 450px) {
  .app__menu_category-container {
    flex: 0 1;
    min-height: none;

    padding-top: 40px;
  }
  .app__menu-heading {
    padding-bottom: 10px;
  }
  .app__menu_container_buttons {
    padding: 20 0;
  }
  .app__menu_menu-item-A_La_Cart {
    padding: 20px 0px;
  }
  .app__menu_menu-item-Menü {
    padding: 20px 0px;
  }
  .app__menu_menu-item-Brunch {
    padding: 20px 0px;
  }
}
@media screen and (max-width: 320px) {
  .app__menu_category {
    font-size: 2.5rem;
  }

  .app__menu_container_buttons {
    gap: 7px;
    padding: 20 0;
    max-width: 300px;
  }
  .app__menu_container_buttons button {
    width: 95px;
  }
  .app__menu_menu-beschreibung {
    font-size: 1.05rem;
    max-width: 300px;
  }
  .app__menu_menu-preise {
    font-size: 1.25rem;
  }
  .app__menu_menu-item-A_La_Cart {
    padding: 20px 0px;
  }
  .app__menu_menu-item-Menü {
    padding: 20px 0px;
  }
  .app__menu_menu-item-Brunch {
    padding: 20px 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/container/Menu/menu.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,mCAAmC;EACnC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,yBAAyB;EACzB,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;EAC1B,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE;IACE,SAAO;IACP,gBAAgB;;IAEhB,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,QAAQ;IACR,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".app__menu_menu-button {\r\n  width: 100px;\r\n  border: solid 0.000000000005em #000;\r\n  height: 27px;\r\n  border-radius: 7px;\r\n  color: #000;\r\n  font-family: \"SawtonCircular-Medium\";\r\n  font-size: 20px;\r\n  font-weight: 550;\r\n  background-color: transparent;\r\n  cursor: pointer;\r\n}\r\n\r\n.app__menu_menu-button.active,\r\n.app__menu_menu-button:hover {\r\n  border: none;\r\n  color: var(--color-white);\r\n  background-color: var(--color-blue);\r\n}\r\n.app__menu_container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  padding: 50px;\r\n}\r\n.app__menu_container_buttons {\r\n  display: flex;\r\n  gap: 15px;\r\n  padding-bottom: 50px;\r\n}\r\n.app__menu_menu-name {\r\n  font-size: 2rem;\r\n  color: #000;\r\n  font-weight: 600;\r\n}\r\n.app__menu_menu-preise {\r\n  font-size: 1.5rem;\r\n  color: #000;\r\n  font-weight: 600;\r\n}\r\n.app__menu_menu-beschreibung {\r\n  font-size: 1.25rem;\r\n}\r\n\r\n.app__menu_menu-item-Menü {\r\n  text-align: center;\r\n  padding: 20px;\r\n}\r\n.app__menu_menu-item-Brunch {\r\n  text-align: center;\r\n  padding: 5px 20px;\r\n}\r\n.app__menu_menu-item-A_La_Cart {\r\n  text-align: center;\r\n  padding: 20px;\r\n}\r\n.app__menu_category {\r\n  font-size: 3rem;\r\n  color: #000;\r\n  font-weight: 600;\r\n}\r\n.app__menu-heading {\r\n  padding-bottom: 50px;\r\n}\r\n.app__menu_category-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  text-align: center;\r\n  flex: 1 0 calc(50% - 10px);\r\n  width: unset;\r\n  min-height: 350px;\r\n}\r\n.app__menu_items_container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n}\r\n.app__menu_container-text {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-align: center;\r\n  max-width: 500px;\r\n}\r\n.app__menu_container-text_heading {\r\n  font-size: 3rem;\r\n  color: #000;\r\n  font-weight: 600;\r\n  padding: 20px 0;\r\n}\r\n.app__menu_container-text_beschreibung {\r\n  font-size: 1.25rem;\r\n  line-height: 30px;\r\n  padding-bottom: 50px;\r\n}\r\n@media screen and (max-width: 450px) {\r\n  .app__menu_category-container {\r\n    flex: 0;\r\n    min-height: none;\r\n\r\n    padding-top: 40px;\r\n  }\r\n  .app__menu-heading {\r\n    padding-bottom: 10px;\r\n  }\r\n  .app__menu_container_buttons {\r\n    padding: 20 0;\r\n  }\r\n  .app__menu_menu-item-A_La_Cart {\r\n    padding: 20px 0px;\r\n  }\r\n  .app__menu_menu-item-Menü {\r\n    padding: 20px 0px;\r\n  }\r\n  .app__menu_menu-item-Brunch {\r\n    padding: 20px 0px;\r\n  }\r\n}\r\n@media screen and (max-width: 320px) {\r\n  .app__menu_category {\r\n    font-size: 2.5rem;\r\n  }\r\n\r\n  .app__menu_container_buttons {\r\n    gap: 7px;\r\n    padding: 20 0;\r\n    max-width: 300px;\r\n  }\r\n  .app__menu_container_buttons button {\r\n    width: 95px;\r\n  }\r\n  .app__menu_menu-beschreibung {\r\n    font-size: 1.05rem;\r\n    max-width: 300px;\r\n  }\r\n  .app__menu_menu-preise {\r\n    font-size: 1.25rem;\r\n  }\r\n  .app__menu_menu-item-A_La_Cart {\r\n    padding: 20px 0px;\r\n  }\r\n  .app__menu_menu-item-Menü {\r\n    padding: 20px 0px;\r\n  }\r\n  .app__menu_menu-item-Brunch {\r\n    padding: 20px 0px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
